import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './translations/en.json';
import LngDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-http-backend';
import moment from 'moment';
import dayjs from 'dayjs';
const resources = {
    en: {
        translation: translationEN
    }
};
i18n.use(XHR)
    .use(LngDetector)
    .use(initReactI18next)
    .init({
    resources,
    // The portal UI is English-only: do not let browser detection switch dates to e.g. Dutch.
    lng: 'en',
    fallbackLng: 'en',
    keySeparator: '.',
    interpolation: {
        escapeValue: false
    }
});
// Date libraries format with the global locale; keep them English too (App.tsx also syncs moment to i18n.language).
moment.locale('en');
dayjs.locale('en');
export default i18n;
